export const operationDecider = (operation_type: string) => {
  //Temp while we convert from a string to an array in ES
  //Right now we have a weird mix of
  //1) Values that are just string "Harvest"
  //2) Arrays that are stored as strings "['Harvest']"
  //3) Actual arrays ['Harvest']
  //Long term they will be arrays as an operation can contain multiple actions (eg Application and Planting)
  let op_to_check = operation_type;
  if (!operation_type) {
    op_to_check = ''
  } else if (Array.isArray(operation_type)) {
    op_to_check = operation_type[0]
  }
  else if (operation_type.startsWith("['")) {
    op_to_check = operation_type.replace("['", "").replace("']", "");
  }

  switch (op_to_check) {
    case 'HARVEST':
    case 'HARVESTING':
      return 'HARVEST'
    case 'TILLAGE':
      return 'TILLAGE'
    case 'PLANTING':
    case 'PLANTING_AND_SOWING':
      return 'PLANTING'
    case 'APPLICATION':
    case 'CROP_PROTECTION':
      return 'APPLICATION'
    default:
      return 'MISSING_OPERATION'
  }
}

export enum OperationType {
  observation = 'OBSERVATION',
  tillage = 'TILLAGE',
  planting = 'PLANTING',
  application = 'APPLICATION',
  irrigation = 'IRRIGATION',
  harvest = 'HARVEST',
  missing = 'MISSING_OPERATION'
}

export const operations = [{
  "label": "Observation",
  "value": OperationType.observation
},
{
  "label": "Tillage",
  "value": OperationType.tillage
},
{
  "label": "Planting",
  "value": OperationType.planting
},
{
  "label": "Application",
  "value": OperationType.application
},
{
  "label": "Irrigation",
  "value": OperationType.irrigation
},
{
  "label": "Harvest",
  "value": OperationType.harvest
}
]